import { render, staticRenderFns } from "./Finalizacao.vue?vue&type=template&id=5ccb9de1&scoped=true"
import script from "./Finalizacao.vue?vue&type=script&lang=js"
export * from "./Finalizacao.vue?vue&type=script&lang=js"
import style0 from "./Finalizacao.vue?vue&type=style&index=0&id=5ccb9de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb9de1",
  null
  
)

export default component.exports